import {ElevationApp} from "../ElevationApp";
import {MdSelection, selectionGroupOf} from "../model/view/MdViewSettings";
import {useEventEmitter2} from "../util/useEventEmitter2";
import {StickSelection} from "./selectedTab/StickSelection";
import {DoorLiteSelection} from "./selectedTab/DoorLiteSelection";
import {CellSelection} from "./selectedTab/CellSelection";
import {HardwareItemSelection} from "./selectedTab/HardwareItemSelection";
import {HingeSelection} from "./selectedTab/HingeSelection";
import {VoidSelection} from "./selectedTab/VoidSelection";
import {DoorSlotSelection} from "./selectedTab/DoorSlotSelection";

// the contextual "Selected XX" ribbon tab. Its content depends on what's selected
// on the canvas: a stick offers inserts, a lite/panel offers a fill toggle and
// splits. All actions mutate the frame model via BlockOps and fire
// frameBlocksChanged so the grid view rebuilds.
export function SelectedTab(props: {app: ElevationApp}) {
    const selection = useEventEmitter2(props.app.viewSettings.selection);
    if(!selection || selection.length === 0) return null;

    // the selection is always single-group (see MdViewSettings.selectItem), so the
    // first element's group picks the contextual tab; each tab handles 1..N items.
    switch(selectionGroupOf(selection[0].type)) {
        case "stick":
            return <StickSelection app={props.app} selection={selection as Extract<MdSelection, {type: "stick"}>[]} />;
        case "door-lite":
            return <DoorLiteSelection app={props.app} selection={selection as Extract<MdSelection, {type: "door-lite"}>[]} />;
        case "hardware-item":
            return <HardwareItemSelection app={props.app} selection={selection as Extract<MdSelection, {type: "hardware-item"}>[]} />;
        case "cell":
            return <CellSelection app={props.app} selection={selection as Extract<MdSelection, {type: "lite" | "panel"}>[]} />;
        case "hinge":
            return <HingeSelection app={props.app} selection={selection as Extract<MdSelection, {type: "hinge"}>[]} />;
        case "void":
            return <VoidSelection app={props.app} selection={selection as Extract<MdSelection, {type: "void"}>[]} />;
        case "door-slot":
            return <DoorSlotSelection app={props.app} selection={selection as Extract<MdSelection, {type: "door-slot"}>[]} />;
        case "anchor":
            // anchors are edited on the Setup Anchors tab (see AnchorSetupTab).
            return null;
    }
}
